import { Progress } from 'antd';
import React from 'react';
import './style.scss';

export const SpeedInfoRow = ({ title, percent }) => (
  <div className="speed_row">
    <div className="speed_row_header">
      {title}
    </div>
    <div className="speed_row_progress">
      <Progress
        percent={percent}
        format={() => {
        }}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/SpeedInfoRow/index.js